import { render, staticRenderFns } from "./StepInitialLetterCreation.vue?vue&type=template&id=6aa8bdc9&scoped=true&"
import script from "./StepInitialLetterCreation.vue?vue&type=script&lang=js&"
export * from "./StepInitialLetterCreation.vue?vue&type=script&lang=js&"
import style0 from "./StepInitialLetterCreation.vue?vue&type=style&index=0&id=6aa8bdc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa8bdc9",
  null
  
)

export default component.exports